import React from "react";
import { Link } from "react-router-dom";
import { FaThLarge, FaSearch } from "react-icons/fa";

// "All episodes" and "Search stories" for the top bar of the story and episode pages
// (Bhaskar, 2026-10-21). Labels show on wider screens; phones get the icons.
export default function BrowseLinks() {
  const pill =
    "flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-kk-gold/25 text-kk-gold/80 " +
    "hover:text-kk-gold hover:border-kk-gold/60 transition-colors text-xs whitespace-nowrap";
  return (
    <nav className="flex items-center gap-2 flex-shrink-0" aria-label="Browse Kathakala">
      <Link to="/episodes" className={pill} title="All episodes · ఎపిసోడ్‌లు">
        <FaThLarge className="text-[11px]" />
        <span className="hidden md:inline">
          <span className="font-krushna text-[13px]">ఎపిసోడ్‌లు</span> · All episodes
        </span>
      </Link>
      <Link to="/?search=1" className={pill} title="Search stories · కథలు వెతకండి">
        <FaSearch className="text-[11px]" />
        <span className="hidden md:inline">
          <span className="font-krushna text-[13px]">కథలు వెతకండి</span> · Search
        </span>
      </Link>
    </nav>
  );
}
